
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Urbaniarentalsinkarvenagarkothrud() {



    const cardData =
    {
        keyword: 'Urbania Rental in Karve Nagar Kothrud ',
        heading: 'Amruta Travels: Urbania Rental in Karve Nagar Kothrud ',
        headingDescription: 'Amruta Travels offers Urbania Rental in Karve Nagar Kothrud, providing a comfortable and reliable solution for group travel, including corporate trips, family outings, airport transfers, school excursions, and weekend getaways. Our 13-seater and 17-seater Force Urbania vans feature spacious interiors, air-conditioning, and modern amenities to ensure a smooth and enjoyable journey. With professional drivers, punctual service, competitive pricing, and 24/7 support, Amruta Travels makes Urbania rental in Karve Nagar Kothrud safe, convenient, and hassle-free.',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



  "services": [
    {
      "name": "Urbania bus rental in Karve Nagar Kothrud",
      "description": "Urbania bus rental in Karve Nagar Kothrud offering comfortable AC buses for family trips, corporate travel, and group outings."
    },
    {
      "name": "Force Urbania bus on rent Karve Nagar",
      "description": "Force Urbania bus on rent in Karve Nagar for luxury group travel, VIP transfers, and city tours with experienced drivers."
    },
    {
      "name": "Urbania bus hire in Karve Nagar Pune",
      "description": "Urbania bus hire in Karve Nagar Pune suitable for city tours, outstation trips, and family excursions with AC comfort."
    },
    {
      "name": "Urbania bus rental service Kothrud",
      "description": "Urbania bus rental service in Kothrud providing reliable bookings for local, outstation, and corporate travel."
    },
    {
      "name": "13 seater Urbania bus on rent Karve Nagar",
      "description": "13 seater Urbania bus on rent in Karve Nagar, perfect for small families or corporate teams with spacious AC interiors."
    },
    {
      "name": "17 Seater Urbania bus Rental Kothrud",
      "description": "17 seater Urbania bus rental in Kothrud for larger groups, weddings, corporate outings, and outstation tours."
    },
    {
      "name": "Luxury Urbania bus hire Karve Nagar",
      "description": "Luxury Urbania bus hire in Karve Nagar with elegant interiors, premium seating, and professional chauffeurs."
    },
    {
      "name": "AC Urbania bus hire Kothrud",
      "description": "AC Urbania bus hire in Kothrud ensuring cool and comfortable travel for both city tours and long-distance journeys."
    },
    {
      "name": "Force Urbania 17 seater bus Karve Nagar",
      "description": "Force Urbania 17 seater bus in Karve Nagar for corporate travel, family trips, and group sightseeing with AC comfort."
    },
    {
      "name": "Urbania bus on rent near Paud Road",
      "description": "Urbania bus on rent near Paud Road providing easy accessibility for Kothrud and Karve Nagar residents."
    },
    {
      "name": "Urbania bus hire near Ideal Colony",
      "description": "Urbania bus hire near Ideal Colony for convenient city travel, local sightseeing, and corporate trips."
    },
    {
      "name": "Urbania bus rental near Bavdhan",
      "description": "Urbania bus rental near Bavdhan for group travel, family outings, and outstation tours with AC comfort."
    },
    {
      "name": "Urbania bus on rent near Warje Malwadi",
      "description": "Urbania bus on rent near Warje Malwadi offering safe, reliable, and comfortable group transport."
    },
    {
      "name": "Urbania bus hire near Karve Road",
      "description": "Urbania bus hire near Karve Road for city tours, airport transfers, and corporate travel with professional service."
    },
    {
      "name": "Urbania bus rental Karve Nagar for family trip",
      "description": "Urbania bus rental in Karve Nagar ideal for family trips, weekend getaways, and group outings with AC interiors."
    },
    {
      "name": "Urbania bus hire Kothrud for outstation",
      "description": "Urbania bus hire in Kothrud for outstation travel to nearby hill stations, pilgrimage spots, and weekend destinations."
    },
    {
      "name": "Urbania bus on rent Karve Nagar for wedding",
      "description": "Urbania bus on rent in Karve Nagar for weddings and events with luxury seating and spacious AC interiors."
    },
    {
      "name": "Urbania bus hire Kothrud for corporate travel",
      "description": "Urbania bus hire in Kothrud for corporate trips, staff transport, meetings, and conferences."
    },
    {
      "name": "Urbania bus rental Karve Nagar for picnic",
      "description": "Urbania bus rental in Karve Nagar for picnics, day trips, and group excursions with comfortable AC seating."
    },
    {
      "name": "Urbania bus rental Karve Nagar price",
      "description": "Urbania bus rental price in Karve Nagar with transparent and affordable rates for families, corporate groups, and events."
    },
    {
      "name": "Urbania bus hire Kothrud per km rate",
      "description": "Urbania bus hire in Kothrud available on per km basis for local, outstation, and airport trips with flexible pricing."
    },
    {
      "name": "Affordable Urbania bus rental Karve Nagar",
      "description": "Affordable Urbania bus rental in Karve Nagar providing AC comfort and reliable service at budget-friendly rates."
    },
    {
      "name": "Cheap Urbania on rent Kothrud",
      "description": "Cheap Urbania on rent in Kothrud for economical group travel without compromising comfort or safety."
    },
    {
      "name": "Best Urbania bus rental service Karve Nagar",
      "description": "Best Urbania bus rental service in Karve Nagar offering well-maintained vehicles, experienced drivers, and punctual service."
    },
    {
      "name": "Book Urbania bus on rent in Karve Nagar",
      "description": "Book Urbania bus on rent in Karve Nagar with easy online booking, flexible schedules, and reliable service."
    },
    {
      "name": "Online Urbania bus booking Kothrud Pune",
      "description": "Online Urbania bus booking in Kothrud Pune for hassle-free reservations and premium bus service."
    },
    {
      "name": "13 Seater Urbania Bus Rental in Karve Nagar Kothrud",
      "description": "13 Seater Urbania Bus Rental in Karve Nagar Kothrud for small groups and family outings with AC comfort."
    },
    {
      "name": "Luxury Force Urbania Bus Hire Karve Nagar",
      "description": "Luxury Force Urbania Bus Hire in Karve Nagar with plush seating, AC interiors, and professional chauffeurs for VIP travel."
    }
  ],
  "tableData": [
    ["Urbania bus rental in Karve Nagar Kothrud", "Force Urbania bus on rent Karve Nagar"],
    ["Urbania bus hire in Karve Nagar Pune", "Urbania bus rental service Kothrud"],
    ["13 seater Urbania bus on rent Karve Nagar", "17 Seater Urbania bus Rental Kothrud"],
    ["Luxury Urbania bus hire Karve Nagar", "AC Urbania bus hire Kothrud"],
    ["Force Urbania 17 seater bus Karve Nagar", "Urbania bus on rent near Paud Road"],
    ["Urbania bus hire near Ideal Colony", "Urbania bus rental near Bavdhan"],
    ["Urbania bus on rent near Warje Malwadi", "Urbania bus hire near Karve Road"],
    ["Urbania bus rental Karve Nagar for family trip", "Urbania bus hire Kothrud for outstation"],
    ["Urbania bus on rent Karve Nagar for wedding", "Urbania bus hire Kothrud for corporate travel"],
    ["Urbania bus rental Karve Nagar for picnic", "Urbania bus rental Karve Nagar price"],
    ["Urbania bus hire Kothrud per km rate", "Affordable Urbania bus rental Karve Nagar"],
    ["Cheap Urbania on rent Kothrud", "Best Urbania bus rental service Karve Nagar"],
    ["Book Urbania bus on rent in Karve Nagar", "Online Urbania bus booking Kothrud Pune"],
    ["13 Seater Urbania Bus Rental in Karve Nagar Kothrud", "Luxury Force Urbania Bus Hire Karve Nagar"]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Reliable Urbania Rental in Karve Nagar Kothrud Pune",
    "WhyChoosedescription": "Amruta Travels offers Urbania Rental in Karve Nagar Kothrud, providing stylish, comfortable, and dependable travel solutions for corporate trips, family outings, and group travel."
  },
  {
    "WhyChooseheading": "Ideal for Corporate, Family, and Event Travel",
    "WhyChoosedescription": "Whether it’s a corporate meeting, family outing, wedding transport, or city sightseeing, our Urbania rentals in Karve Nagar Kothrud ensure a smooth and comfortable journey."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Interiors",
    "WhyChoosedescription": "Urbania vehicles feature plush seating, generous legroom, air conditioning, wide windows, and ample luggage space, making them perfect for short city rides and long-distance trips."
  },
  {
    "WhyChooseheading": "Professional and Courteous Drivers",
    "WhyChoosedescription": "All Urbania rentals come with trained and courteous drivers who ensure punctuality, safety, and a pleasant travel experience throughout Karve Nagar, Kothrud, and Pune."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Amruta Travels provides competitive and transparent pricing for Urbania rentals in Karve Nagar Kothrud, giving you excellent value for money without any hidden charges."
  },
  {
    "WhyChooseheading": "Clean, Well-Maintained, and Sanitized Vehicles",
    "WhyChoosedescription": "Our Urbania vehicles are regularly serviced and sanitized to maintain high standards of hygiene, safety, and passenger comfort."
  },
  {
    "WhyChooseheading": "Flexible Pickup, Drop-Off, and Route Options",
    "WhyChoosedescription": "We offer flexible pickup and drop-off locations with customized routes to suit your travel plan within Karve Nagar, Kothrud, Pune, or nearby destinations."
  },
  {
    "WhyChooseheading": "Easy Booking with Dedicated Support",
    "WhyChoosedescription": "Booking an Urbania rental in Karve Nagar Kothrud Pune is simple and hassle-free with Amruta Travels. Our support team assists you at every step for a seamless experience."
  }
]

    }

const faqData = [
  {
    question: 'How can I book an Urbania rental in Karve Nagar Kothrud Pune?',
    answer: 'You can book an Urbania rental in Karve Nagar Kothrud Pune by contacting Amruta Travels online, via phone, or by visiting our office. Our team will assist you throughout the booking process.'
  },
  {
    question: 'Is Urbania suitable for corporate travel from Karve Nagar Kothrud?',
    answer: 'Yes, Urbania is ideal for corporate travel, offering spacious seating, air conditioning, and comfort for employees and clients traveling from Karve Nagar Kothrud.'
  },
  {
    question: 'Can I hire Urbania in Karve Nagar Kothrud for outstation trips?',
    answer: 'Yes, we provide Urbania rentals from Karve Nagar Kothrud for both local and outstation travel, ensuring a smooth and comfortable journey.'
  },
  {
    question: 'Does the Urbania rental include a driver?',
    answer: 'Yes, every Urbania rental includes a professional and experienced driver for safe and hassle-free travel.'
  },
  {
    question: 'Are the Urbania vehicles well-maintained?',
    answer: 'Absolutely. All our Urbania vehicles are regularly serviced, cleaned, and sanitized to maintain hygiene, safety, and passenger comfort.'
  },
  {
    question: 'What is the cost of Urbania rental in Karve Nagar Kothrud Pune?',
    answer: 'The rental cost depends on distance, duration, and type of travel. Contact Amruta Travels for a transparent and customized quote.'
  },
  {
    question: 'Can I customize pickup and drop-off locations in Karve Nagar Kothrud?',
    answer: 'Yes, we offer flexible pickup and drop-off options and route customization based on your travel needs.'
  },
  {
    question: 'Why choose Amruta Travels for Urbania rental in Karve Nagar Kothrud Pune?',
    answer: 'Amruta Travels offers well-maintained Urbania vehicles, professional drivers, transparent pricing, and reliable support, ensuring a premium travel experience.'
  }
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Prasad Kulkarni',
    role: 'Corporate Executive, Karve Nagar Kothrud',
    text: 'We hired an Urbania from Karve Nagar Kothrud for a corporate event. The vehicle was spacious, clean, and comfortable. The driver was professional and punctual. Excellent service by Amruta Travels!',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Shalini Deshmukh',
    role: 'Family Traveler, Karve Nagar Kothrud',
    text: 'Booked an Urbania rental in Karve Nagar Kothrud for a family outing. The ride was smooth, comfortable, and hassle-free. Highly recommend Amruta Travels!',
    rating: 5
  }
];




























































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Bus Rental in Karve Nagar Kothrud",
  "image": "https://bushireinpune.com/assets/images/urbania-karve-nagar-kothrud.jpg",
  "description": "Rent 13 & 17 seater Force Urbania buses in Karve Nagar, Kothrud Pune for family trips, corporate travel, weddings, outstation trips, and sightseeing. Luxury and AC options available for comfortable travel.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "1520"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5000",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/urbania-karve-nagar-kothrud"
  }
};




    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Urbania Bus Rental in Karve Nagar Kothrud | Force Urbania Pune</title>
  <meta
    name="description"
    content="Book 13 & 17 seater Force Urbania buses in Karve Nagar Kothrud, Pune. Ideal for family trips, corporate travel, weddings, outstation trips & sightseeing. Luxury and AC options available."
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/121.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Urbaniarentalsinkarvenagarkothrud;